import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcSearchDropdownComponent } from './fc-search-dropdown.component';

const components = [FcSearchDropdownComponent];
@NgModule({
    imports: [CommonModule],
    declarations: components,
    exports: components
})
export class FcSearchDropdownModule {}
